<i18n>
{
  "en": {
    "messages": {
      "title": "Datetime picker",
      "okButton": "OK"
    }
  },
  "ja": {
    "messages": {
      "title": "日時設定",
      "okButton": "OK"
    }
  }
}
</i18n>

<template>
  <div class="text-xs-center">
    <v-dialog v-model="isShown" width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('messages.title') }}
        </v-card-title>

        <v-flex style="margin: 0px 16px; height: 400px;">
          <CoccoDatePicker :fromNow="true" v-model="shootingDate" />
          <CoccoTimePicker v-model="shootingTime" />
        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="clickCancelButton">
            {{ cancelButtonText || 'キャンセル' }}
          </v-btn>
          <v-btn color="primary" @click="clickOkButton">
            {{ okButtonText || 'OK' }}
          </v-btn>
        </v-card-actions>


      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CoccoDatePicker from '@/components/atoms/CoccoDatePicker';
import CoccoTimePicker from '@/components/atoms/CoccoTimePicker';

export default {
  components: {
    CoccoDatePicker,
    CoccoTimePicker
  },
  computed: {
    isShown: {
      get() {
        return this.dialog;
      },
      set(dialog) {
        this.$emit('cancel');
      }
    }
  },
  methods: {
    clickOkButton: function() {
      this.$emit(
        'input',
        this.shootingDate ? `${this.shootingDate}T${this.shootingTime}:00+09:00` : null
      );
      this.$emit('click');
    },
    clickCancelButton: function() {
      this.$emit('cancel');
    }
  },
  data() {
    return {
      shootingDate: '',
      shootingTime: ''
    }
  },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    okButton: {
      type: String
    },
    cancelButtonText: {
      type: String
    },
    okButtonText: {
      type: String
    },
    dialog: {
      type: Boolean
    }
  }
};
</script>
